import type { ThemePref } from './prefs';

/** Applies the theme preference to <html data-theme>. Dark is the default; 'system' follows the OS. */
export function applyTheme(pref: ThemePref): void {
  document.documentElement.setAttribute('data-theme', pref);
}
